(function() {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function getNextCutoff(now) {
    var target = new Date(now);
    target.setHours(14, 0, 0, 0);
    if (now.getTime() >= target.getTime()) {
      target.setDate(target.getDate() + 1);
    }
    return target;
  }

  function updateTimer(card) {
    var now = new Date();
    var target = getNextCutoff(now);
    var diff = Math.max(0, target.getTime() - now.getTime());
    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var h = card.querySelector('[data-s2g-hours]');
    var m = card.querySelector('[data-s2g-mins]');
    var s = card.querySelector('[data-s2g-secs]');
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  }

  function initS2GDispatchTimers(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-s2g-dispatch-timer]');
    cards.forEach(function(card) {
      if (card.dataset.s2gTimerReady === 'true') return;
      card.dataset.s2gTimerReady = 'true';
      updateTimer(card);
      setInterval(function() { updateTimer(card); }, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function() { initS2GDispatchTimers(document); });
  document.addEventListener('shopify:section:load', function(event) { initS2GDispatchTimers(event.target); });
})();

(function () {
  function bindTimerCards(scope) {
    (scope || document).querySelectorAll('.s2g-dispatch-timer-card').forEach(function (card) {
      if (card.dataset.s2gClickBound === 'true') return;
      card.dataset.s2gClickBound = 'true';
      card.style.cursor = 'pointer';
      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        window.location.href = 'https://shopfittings2go.com/pages/delivery-information';
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { bindTimerCards(document); });
  document.addEventListener('shopify:section:load', function (event) { bindTimerCards(event.target); });
})();
